import * as React from "react";

const SvgIcnBackArrow = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M12.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0 .625.625 0 010 .922l-4.12 3.884 4.126 3.89z"
            />
            <path stroke="currentColor" strokeLinecap="round" strokeWidth={1.25} d="M8 12h10" />
        </g>
    </svg>
);

export default SvgIcnBackArrow;
